import { render, staticRenderFns } from "./UserVideoSetup.vue?vue&type=template&id=081f3c38&"
import script from "./UserVideoSetup.vue?vue&type=script&lang=js&"
export * from "./UserVideoSetup.vue?vue&type=script&lang=js&"
import style0 from "./UserVideoSetup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports